import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-finances',
  template: `
    <app-navigation-secondary-finances></app-navigation-secondary-finances>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryFinancesComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/zh/webapp/src/compat/compat-navigation-secondary-finances.component.ts